'use client';

import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import StudioHero from './components/StudioHero';
import StudioSchedule from './components/StudioSchedule';
import StudioStudents from './components/StudioStudents';
import StudioInstitution from './components/StudioInstitution';
import StudioAnalytics from './components/StudioAnalytics';
import StudioCTA from './components/StudioCTA';

export default function WislyStudioPage() {
    return (
        <main className="min-h-screen overflow-x-hidden" style={{ background: '#FAFAFA', color: '#0D0D0D' }}>
            <Header />
            <StudioHero />
            <StudioSchedule />
            <StudioStudents />
            <StudioInstitution />
            <StudioAnalytics />
            <StudioCTA />
            <Footer />
        </main>
    );
}
